module.exports = __webpack_public_path__ + "media/images/icons/logo-b6432791bc6baa67488a5c32bd1a28a8.png";